import { FormBase } from 'core/components';

export default class DimensionsStepForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'box',
					label: 'FULFILLMENTORDER.LABELINGMODE.DIMENSIONSSTEP.BOXDIMENSIONS',
					rules: 'required',
				},
				{
					name: 'name',
					label: 'FULFILLMENTORDER.LABELINGMODE.DIMENSIONSSTEP.NAME',
					rules: 'required',
				},
				{
					name: 'boxHeight',
					label: 'FULFILLMENTORDER.LABELINGMODE.DIMENSIONSSTEP.HEIGHT',
					rules: 'required|integer',
				},
				{
					name: 'boxWidth',
					label: 'FULFILLMENTORDER.LABELINGMODE.DIMENSIONSSTEP.WIDTH',
					rules: 'required|integer',
				},
				{
					name: 'boxLength',
					label: 'FULFILLMENTORDER.LABELINGMODE.DIMENSIONSSTEP.LENGTH',
					rules: 'required|integer',
				},
			],
		};
	}

	options() {
		return {
			validateOnChange: true,
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/labeling-mode/DimensionsStepForm.js